<!-- src/views/SquareDetail.vue -->
<template>
    <div class="square-detail" :style="{ opacity: opacity }">
        <!-- 图片显示区域 -->
        <div class="img-container" :style="{ height: fullHeight * 0.87 + 'px' }">
            <img v-if="imageUrl" :src="imageUrl" alt="广场详情图片" @load="onImageLoad" @error="onImageError" />

            <!-- 没有图片时的占位内容 -->
            <div v-else class="placeholder-content">
                <p>暂无图片</p>
            </div>

            <!-- 加载状态 -->
            <div class="loading-overlay" v-if="loading">
                <div class="loading-spinner">
                    <div class="spinner"></div>
                    <p>加载中...</p>
                </div>
            </div>

            <!-- 错误状态 -->
            <div class="error-overlay" v-if="imageError">
                <div class="error-content">
                    <img src="../assets/loading.gif" alt="错误" />
                    <p>图片加载失败</p>
                    <button @click="retryLoad" class="retry-btn">重新加载</button>
                </div>
            </div>
        </div>

        <!-- 控制面板 -->
        <div class="control-panel" :style="{ height: fullHeight * 0.13 + 'px' }">
            <div class="control-content">
                <div class="opacity-control">
                    <span class="control-label">不透明度</span>
                    <div class="slider-container">
                        <opacityprogress v-model="opacity" :screenWidth="screenWidth" @input="changeOpacityAction"></opacityprogress>
                    </div>
                    <span class="opacity-value">{{ Number(opacity * 100).toFixed(0) }}%</span>
                </div>

                <!-- 用户信息显示 -->
                <div class="user-info" v-if="userInfo">
                    <span class="user-id">用户ID: {{ userInfo.userid }}</span>
                    <span class="token-info">Token: {{ userInfo.token }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import opacityprogress from "../components/progress/opacity.vue";
import UserMgr from "@/mgr/UserMgr";

export default {
    name: "SquareDetail",

    components: {
        opacityprogress,
    },

    data() {
        return {
            // 图片相关
            imageUrl: "",
            loading: true,
            imageError: false,

            // 控制相关
            opacity: 1,
            fullHeight: document.documentElement.clientHeight,
            screenWidth: document.body.clientWidth,
            timer: null,

            // 用户信息
            userInfo: {
                userid: "",
                token: "",
            },
        };
    },

    created() {
        this.initPage();
    },

    mounted() {
        this.setupResizeListener();
    },

    beforeDestroy() {
        // 清理事件监听
        if (window.onresize) {
            window.onresize = null;
        }
    },

    methods: {
        // 初始化页面
        async initPage() {
            // 获取路由参数
            const { userid, token, product_id } = this.$route.query;
            // 将逗号分隔的字符串转换为数组
            // const productIds = product_id_list ? product_id_list.split(",").map((id) => +id) : [];
            // console.log(productIds);

            const productId = +product_id || 0;
            // 设置用户信息
            this.userInfo = {
                userid: +userid || 0,
                token: token || "",
            };

            // 验证必要参数
            if (!this.userInfo.userid) {
                this.$message.error("缺少用户ID参数");
                return;
            }
            //token
            if (!this.userInfo.token) {
                this.$message.error("缺少Token参数");
                return;
            }

            UserMgr.inst.userInfo = this.userInfo;
            // 获取图片
            this.loading = true;
            if (productId > 0) {
                try {
                    const res = await this.$http.getProduct({ product_id_list: [productId] });
                    if (res.data.ret_code == 0 && res.data.product_list.length > 0) {
                        this.imageUrl = res.data.product_list[0].icon_url;
                    } else {
                        this.$message.error(res.data.ret_msg || "未获取到图片");
                    }
                } catch (e) {
                    this.$message.error("获取图片失败");
                } finally {
                    this.loading = false;
                }
            }
        },

        // 图片加载成功
        onImageLoad() {
            this.loading = false;
            this.imageError = false;
            console.log("图片加载成功");
        },

        // 图片加载失败
        onImageError() {
            this.loading = false;
            this.imageError = true;
            console.error("图片加载失败");
        },

        // 重新加载
        retryLoad() {
            this.loading = true;
            this.imageError = false;
            // 强制重新加载图片
            const img = new Image();
            img.onload = () => {
                this.onImageLoad();
            };
            img.onerror = () => {
                this.onImageError();
            };
            img.src = this.imageUrl;
        },

        // 透明度控制
        changeOpacityAction(value) {
            if (value <= 0.05) {
                value = 0.05;
            }
            this.opacity = Number(value).toFixed(2);
        },

        // 设置窗口大小监听
        setupResizeListener() {
            const that = this;
            window.onresize = () => {
                return (() => {
                    window.fullHeight = document.documentElement.clientHeight;
                    that.fullHeight = window.fullHeight;
                    window.screenWidth = document.body.clientWidth;
                    that.screenWidth = window.screenWidth;
                })();
            };
        },
    },

    watch: {
        fullHeight(val) {
            if (!this.timer) {
                this.fullHeight = val;
                this.timer = true;
                let that = this;
                setTimeout(function () {
                    that.timer = false;
                }, 400);
            }
        },

        screenWidth(val) {
            this.screenWidth = val;
        },
    },
};
</script>

<style lang="scss" scoped>
.square-detail {
    width: 100%;
    height: 100vh;
    background: #000;
    position: relative;

    .img-container {
        width: 100%;
        position: relative;
        overflow: hidden;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            display: block;
        }

        .loading-overlay {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.7);
            display: flex;
            justify-content: center;
            align-items: center;

            .loading-spinner {
                text-align: center;
                color: #fff;

                .spinner {
                    width: 40px;
                    height: 40px;
                    border: 3px solid #fff;
                    border-top: 3px solid transparent;
                    border-radius: 50%;
                    animation: spin 1s linear infinite;
                    margin: 0 auto 10px;
                }

                p {
                    margin: 0;
                    font-size: 14px;
                }
            }
        }

        .error-overlay {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.8);
            display: flex;
            justify-content: center;
            align-items: center;

            .error-content {
                text-align: center;
                color: #fff;

                img {
                    width: 60px;
                    height: 60px;
                    margin-bottom: 10px;
                }

                p {
                    margin: 10px 0;
                    font-size: 14px;
                }

                .retry-btn {
                    background: #fd9552;
                    color: #fff;
                    border: none;
                    padding: 8px 16px;
                    border-radius: 4px;
                    font-size: 12px;
                    cursor: pointer;

                    &:hover {
                        background: #e88442;
                    }
                }
            }
        }
    }

    .control-panel {
        width: 100%;
        background: rgba(0, 0, 0, 0.6);
        display: flex;
        align-items: center;
        justify-content: center;
        .control-content {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            .opacity-control {
                display: flex;
                align-items: center;
                width: 100%;
                .control-label {
                    color: #fff;
                    font-size: 14px;
                    margin-right: 10px;
                }
                .slider-container {
                    width: 60%;
                    margin: 0 10px;
                }
                .opacity-value {
                    color: #fff;
                    font-size: 14px;
                    margin-left: 10px;
                }
            }
            .user-info {
                margin-top: 10px;
                color: #fff;
                font-size: 12px;
                .user-id {
                    margin-right: 20px;
                }
                .token-info {
                    color: #fd9552;
                }
            }
        }
    }
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
